import { render, staticRenderFns } from "./profit_transfer_list.vue?vue&type=template&id=5d1234f8"
import script from "./profit_transfer_list.vue?vue&type=script&lang=js"
export * from "./profit_transfer_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports